import { __makeTemplateObject } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { useResponsiveValue } from '../../hooks/use-match-media.js';
import { Box } from '../box/Box.js';
import { Card } from '../card/Card.js';
import { Overlay } from '../overlay/Overlay.js';

var sizeConstants = {
  sm: "33%",
  md: "66%",
  lg: "90%",
  fit: "auto"
};
var translateMap = {
  left: "-100%, 0%",
  right: "100%, 0%",
  top: "0%, -100%",
  bottom: "0%, 100%"
};
var DrawerCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "Drawer__DrawerCard",
  componentId: "sc-1nd7ug0-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  transform: translate(\n    ", "\n  );\n  transition: transform 0.2s ease;\n"], ["\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  transform: translate(\n    ", "\n  );\n  transition: transform 0.2s ease;\n"])), function (_a) {
  var isOpen = _a.isOpen,
    from = _a.from;
  return isOpen ? "0%, 0%" : translateMap[from];
});
var Drawer = function (_a) {
  var _b = _a.from,
    from = _b === void 0 ? "bottom" : _b,
    _c = _a.size,
    size = _c === void 0 ? "md" : _c,
    isOpen = _a.isOpen,
    onClose = _a.onClose,
    children = _a.children;
  var fromString = useResponsiveValue(from);
  var sizeString = useResponsiveValue(size);
  var isVertical = ["top", "bottom"].includes(fromString);
  return React__default.createElement(Box, null, React__default.createElement(Overlay, {
    onClick: onClose,
    visible: isOpen
  }), React__default.createElement(DrawerCard, {
    display: "block",
    height: isVertical ? sizeConstants[sizeString] : "100%",
    width: isVertical ? "100%" : sizeConstants[sizeString],
    maxWidth: "100%",
    maxHeight: "100%",
    backgroundColor: "white",
    position: "fixed",
    left: fromString === "right" ? "auto" : 0,
    right: fromString === "left" ? "auto" : 0,
    top: fromString === "bottom" ? "auto" : 0,
    bottom: fromString === "top" ? "auto" : 0,
    isOpen: isOpen,
    from: fromString,
    zIndex: 9999
  }, children));
};
var templateObject_1;

export { Drawer };
//# sourceMappingURL=Drawer.js.map
